import { defineComponent as _defineComponent } from 'vue'
import { useEventQuery } from '@/enitites/event/api/queries'
import { useImage } from '@/shared/composables/image'
import { useMyTicketsForEventQuery } from '@/features/tickets/api/queries'
import TicketLeft from '@/features/tickets/assets/TicketLeft.vue'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { ref, watch } from 'vue'
import { mdiClose } from '@mdi/js'
import { ITicketPurchased } from '@/features/tickets/types'
import SelectedTicket from '@/features/tickets/ui/SelectedTicket.vue'
import TicketAssignmentInterface from '@/features/tickets/ui/TicketAssignmentInterface.vue'
import ChangeTierInterface from '@/features/tickets/ui/ChangeTierInterface.vue'
import RefundTicketInterface from '@/features/tickets/ui/RefundTicketInterface.vue'
import PurchaseReceipt from '@/features/tickets/ui/PurchaseReceipt.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyTicketsInterface',
  props: {
    eventId: null,
    selectedTicketId: null
  },
  setup(__props: any) {

const props = __props as {
  eventId: number
  selectedTicketId?: number
};



const { getImageById } = useImage()
const { data: event, isLoading: isLoadingEvent, isError: isEventError } = useEventQuery(props.eventId)
const { data: myTickets } = useMyTicketsForEventQuery(props.eventId)

const selectedTicket = ref<ITicketPurchased | undefined>(undefined)
const isShowAssignmentInterface = ref(false)
const isShowSuccessAssignmentMessage = ref(false)
const isShowChangeTierInterface = ref(false)
const isShowRefundInterface = ref(false)
const isShowReceiptInterface = ref(false)

watch(
  () => myTickets.value,
  (newTickets) => {
    if (!newTickets || newTickets.length === 0) return

    if (!selectedTicket.value) {
      const selectedTicketId = props.selectedTicketId || newTickets[0].id
      const foundTicket = newTickets.find((ticket) => ticket.id === selectedTicketId)
      selectedTicket.value = foundTicket || newTickets[0]
    } else {
      // Keep selectedTicket in sync after mutations (e.g. tier change)
      const updated = newTickets.find((ticket) => ticket.id === selectedTicket.value!.id)
      if (updated) selectedTicket.value = updated
    }
  },
  { immediate: true }
)

watch(
  () => selectedTicket.value,
  () => {
    isShowAssignmentInterface.value = false
    isShowChangeTierInterface.value = false
    isShowRefundInterface.value = false
    isShowReceiptInterface.value = false
  }
)

return { __sfc: true,props, getImageById, event, isLoadingEvent, isEventError, myTickets, selectedTicket, isShowAssignmentInterface, isShowSuccessAssignmentMessage, isShowChangeTierInterface, isShowRefundInterface, isShowReceiptInterface, TicketLeft, AvatarPlaceholder, mdiClose, SelectedTicket, TicketAssignmentInterface, ChangeTierInterface, RefundTicketInterface, PurchaseReceipt }
}

})